<div class="d-flex flex-column align-items-center my-4 overflow-hidden">
    <adapt-team-meeting-guidance-dashboard-element [team]="team"></adapt-team-meeting-guidance-dashboard-element>

    <button *adaptIfAuthorised="StewardshipWorkMeetingsEdit"
            class="btn btn-primary px-4 mt-3"
            [adaptBlockingClick]="showGuidance">Set meeting guidance
    </button>
</div>
